import React from 'react'

import useTranslation from '@/Hooks/UseTranslation'
import { RelationDescription } from './RelationTypeSelector'

import './RelationItem.scss'

type Props = {
  type: string
  originName?: string | null
  destinationName?: string | null
  lag: number
  onSelect?: () => void
}

type TextProps = Omit<Props, 'onSelect'> & {
  originContent?: React.ReactNode
  destinationContent?: React.ReactNode
}

export const RelationSummaryText = ({
  type,
  originName,
  destinationName,
  originContent,
  destinationContent,
  lag,
}: TextProps) => {

  const { t } = useTranslation()
  const lagAsNumber = Number(lag) || 0
  const lagLabel = lagAsNumber
    ? lagAsNumber > 0 ? ` + ${lagAsNumber}d` : ` ${lagAsNumber}d`
    : ''

  return (
    <>
      <RelationDescription
        description={t(`RELATIONS_CREATOR:PresetDescription:${type}`)}
        originName={originContent || originName || t('RELATIONS_CREATOR:Nameless')}
        destinationName={destinationContent || destinationName || t('RELATIONS_CREATOR:Nameless')}
      />
      {lagLabel}
    </>
  )
}

const RelationSummaryItem = ({ type, originName, destinationName, lag, onSelect }: Props) => (
  <div className="relation-item">
    <div className="relation-item-header">
      <div
        className={`relation-item-name${onSelect ? ' selectable' : ''}`}
        onClick={onSelect}
      >
        <RelationSummaryText
          type={type}
          originName={originName}
          destinationName={destinationName}
          lag={lag}
        />
      </div>
    </div>
  </div>
)

export default RelationSummaryItem
